import React from 'react';
import classNameBind from 'classnames/bind';
import { errorBoundary } from '@piwikpro/platform';
import {
  Stack,
  withTranslation,
  Card,
  Icon,
  Tag,
  Text,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { AuthState } from '@piwikpro/auth-crate';
import styles from './SamlStatus.module.css';

export interface ISamlStatusProps {
  formExpanded: boolean
  setFormExpanded: (newState: boolean) => void
  isSamlEnabled: boolean
  t: TFunction
}

const bindClasses = classNameBind.bind(styles);

const mapStateToProps = (state: AuthState) => ({
  isSamlEnabled: state.authSettings.organization.saml.enabled,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

export const SamlStatus: React.FunctionComponent<ISamlStatusProps & ReduxProps> = ({
  formExpanded,
  setFormExpanded,
  isSamlEnabled,
  t,
}) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div
    className={bindClasses('clickable-card')}
    onClick={() => setFormExpanded(!formExpanded)}
    role="button"
    tabIndex={0}
  >
    <Card.Section subdued>
      <Stack verticalAlignment="center" spacing="narrow">
        <Stack.Item>
          <Icon
            name="chevron-right"
            size="default"
            className={bindClasses('rotate-transition', {
              'rotate-down': formExpanded,
              'rotate-up': !formExpanded,
            })}
          />
        </Stack.Item>
        <Stack.Item>
          <Text as="p" weight={600} dataId="Label">{t('accountSecurity.saml-settings.section.tittle')}</Text>
        </Stack.Item>
        <Stack.Item>
          <Tag
            color={isSamlEnabled ? 'green' : 'gray'}
          >
            {t(
              isSamlEnabled
                ? 'accountSecurity.saml-settings.section.status-on'
                : 'accountSecurity.saml-settings.section.status-off',
            )}
          </Tag>
        </Stack.Item>
      </Stack>
    </Card.Section>
  </div>
);

export default connector(withTranslation(['administration'])(errorBoundary(SamlStatus)));
